<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130">
       
         <Row >
            <Col span="24">
                  <FormItem label="类别:" prop="content">                   
                     <RadioGroup v-model="formValidate.content"  vertical>
                          <Radio label="涉嫌未经许可经营旅行社业务">  </Radio>
                          <Radio label="涉嫌低价游产品"> </Radio>
                          <Radio label="涉嫌未经许可经营演出票务活动"> </Radio>
                          <Radio label="涉嫌外籍人士违规演出"> </Radio>
                          <Radio label="涉嫌发布违规网络文化产品"> </Radio>
                          <Radio label="其他"><span> 其他 &nbsp; <Input v-model="name"  placeholder="请输入违规内容" ></Input></span> </Radio>
                      </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
    
        
       
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import moment from 'moment'
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title:'',
        name: '',
      
        formValidate: {
          _id: '',
          content:'涉嫌低价游产品',
        },
        ruleValidate: {
          content: [{
            required: true,
            message: '请选择类别',
            trigger: 'change'
          }]
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
        if(row!=null){
          this.formValidate=row    
          this.formValidate._id=row._id     
        }
      },  
    
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  '/api/data/clue' 
            let _content=this.formValidate.content
            if(_content=='其他'){
                if(this.name==''){
                   alert("请输入违规内容");
                   return;
                }else{
                  _content+="——"+this.name
                }
            }
              let myData = {
                type:3,
                _id: this.formValidate._id,             
                tag: _content,
                isClue: 1,   //确认线索
              }
             this.req({
                        url: url,
                        method: 'post',
                        data: myData ,
                    }).then(resp => {
                        	if(resp.data.code==200){
								           this.$Message.info(resp.data.msg)
                           this.$parent.loadPage();
                    }else{
                      this.$Message.error(resp.data.msg);
                      if(resp.data.msg=="缺少参数token"){
                        this.$Message.error("登录过期，请重新登录");
                        this.$router.push("/login");
                      }
                    }
                        this.userForm = false;
                    }).catch(error => {
                    this.$Message.error('服务器错误:' + error)
                    })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/suspected/addConfirm.vue